import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-eroor404',
  templateUrl: './eroor404.component.html',
  styleUrls: ['./eroor404.component.css']
})
export class Eroor404Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
